$(function () {
    // Filters

    $(document).on('click', '.js-toggle-filters', function (e) {
        e.preventDefault();

        if ($(".js-popup-filter-container").children().length == 0) {
            $.ajax({
                url: 'Ads/FilterPopup',
                success: function (html) {
                    $(".js-popup-filter-container").html(html);
                    $('.js-filters-container').addClass('c-filter-popup--visible');
                    $('body').addClass('u-no-scroll');
                    desktopFilterMenu()
                }
            });
        } else {
            $('.js-filters-container').toggleClass('c-filter-popup--visible');
            $('body').toggleClass('u-no-scroll');
        }
    });

    $(document).on('click', '.js-filter-link', function (e) {
        $('.js-filter-link').removeClass('c-filter-popup__menu-item--active');
        $(this).addClass('c-filter-popup__menu-item--active');
        $('.js-filter-more').removeClass('c-filter-popup__menu-more--visible');
    });

    if ($('.js-filter-item').length >= 10) {
        $('.js-filters-show-all').addClass('c-list-filters__show-all--visible');
    }

    $(document).on('click', '.js-filters-show-all', function (e) {
        e.preventDefault();
        $('.js-filters-show-all').removeClass('c-list-filters__show-all--visible');
        $('.js-filter-item').addClass('visible');
    });

    $(document).on('click', '.js-filter-more-toggle', function (e) {
        e.preventDefault();
        $('.js-filter-more').toggleClass('c-filter-popup__menu-more--visible');
    });

    $(document).on('click', '.js-filter-more-link', function (e) {
        e.preventDefault();
        $(this).hide();
        $(this).siblings('.js-filter-input-wrapper').addClass('c-filter-popup__input-wrapper--show-all');
    });

    var desktopFilterMenuIterator = 0;

    function desktopFilterMenu() {
        var mq = window.matchMedia("(min-width: 1024px)");

        if (mq.matches) {
            var totalWidth = 0;

            $('.js-filter-menu .js-filter-link').each(function () {
                var itemWidth = $(this).width() + 32;
                totalWidth += itemWidth;
            });

            totalWidth += 43;
            desktopFilterMenuIterator++;

            if (totalWidth > $('.js-filter-width').width() && desktopFilterMenuIterator != 100) {
                $('.js-filter-menu .js-filter-link:last-of-type').prependTo('.js-filter-more');
                desktopFilterMenu();
                if (!$('.js-filter-more-container').hasClass('c-filter-popup__menu-more-container--visible')) {
                    $('.js-filter-more-container').addClass('c-filter-popup__menu-more-container--visible');
                }
            } else {
                return;
            }
        }
    };

    $(document).on('click', '.js-filter-more-close', function () {
        $('.js-filter-more').removeClass('c-filter-popup__menu-more--visible');
    });

    desktopFilterMenu();

    $('.js-slider-target').each(function () {
        initSlider($(this).attr('id'));
    });

    function initSlider(sliderID) {
        var slider = document.getElementById(sliderID);

        if (!slider) return;;

        var slider_min = parseFloat($('#' + sliderID + '_min').val());
        var slider_max = parseFloat($('#' + sliderID + '_max').val());


        var slider_min_range = parseFloat($('#' + sliderID + '_min').attr('data-slider-value'));
        var slider_max_range = parseFloat($('#' + sliderID + '_max').attr('data-slider-value'));
        noUiSlider.create(slider, {
            start: [slider_min, slider_max],
            connect: true,
            step: 1,
            range: {
                'min': slider_min_range,
                'max': slider_max_range
            }
        });

        slider.noUiSlider.on('update', function () {
            $('#' + sliderID + '_min').val(parseFloat(slider.noUiSlider.get()[0]));
            $('#' + sliderID + '_max').val(parseFloat(slider.noUiSlider.get()[1]));
        });

        slider.noUiSlider.on('start', function () {
            slider_min = $('#' + sliderID + '_min').val();
            slider_max = $('#' + sliderID + '_max').val();
        });

        slider.noUiSlider.on('set', function () {
            if ($('#' + sliderID + '_min').val() != slider_min) {
                filterChange($('#' + sliderID + '_min'));
            }
            if ($('#' + sliderID + '_max').val() != slider_max) {
                filterChange($('#' + sliderID + '_max'));
            }
        });

        $('#' + sliderID + '_min').on('change', function () {
            slider.noUiSlider.set([$(this).val(), null]);
        });

        $('#' + sliderID + '_max').on('change', function () {
            slider.noUiSlider.set([null, $(this).val()]);
        });
    }
    $('.js-value-slider-target').each(function () {
        initSingleValueSlider($(this).attr('id'));
    });

    function initSingleValueSlider(sliderID) {
        var slider = document.getElementById(sliderID);

        if (!slider) return;;

        var input = $('#' + sliderID + '_max');

        var slider_value = parseFloat(input.val());

        var slider_min_range = parseFloat(input.attr('min'));
        var slider_max_range = parseFloat(input.attr('max'));

        if (isNaN(slider_value)) {
            slider_value = slider_max_range;
        }

        noUiSlider.create(slider, {
            start: slider_value,
            connect: 'lower',
            step: 1,
            range: {
                'min': slider_min_range,
                'max': slider_max_range
            }
        });

        slider.noUiSlider.on('update', function () {
            $('#' + sliderID + '_max').val(parseFloat(slider.noUiSlider.get()));
        });

        slider.noUiSlider.on('start', function () {
            slider_value = $('#' + sliderID + '_max').val();
        });

        slider.noUiSlider.on('set', function () {
            if ($('#' + sliderID + '_max').val() != slider_value) {
                input.change();

                filterChange($('#' + sliderID + '_max'));
            }
        });

        $('#' + sliderID + '_max').on('change', function () {
            slider_value = parseFloat($(this).val());
            slider.noUiSlider.set($(this).val());
        });
    }

    function filterChange() {
        // TODO: ???
    }

    $(document).on('change', '.js-filter-by-location', function (e) {
        if (this.checked) {
            DisableSubmit();
            storeLocation($(this), EnableSubmit);
        }
        else {
            removeLocation();
        }
    });

    $(document).on('change', '.js-filter-by-area', function () {
        const filterByLocationCheckbox = $(this).closest('form').find('.js-filter-by-location');

        if (!filterByLocationCheckbox.is(':checked')) {
            filterByLocationCheckbox.prop("checked", true);
            filterByLocationCheckbox.change();
        }
    });

    if ($('.js-filter-by-location').is(':checked')) {
        DisableRegions();

        // Set a location from the browser while the page loads
        DisableSubmit();
        storeLocation($('.js-filter-by-location'), EnableSubmit);
    }

    // Small filters

    // Things to hide on click

    function closeSmallFilters() {
        if ($('.c-small-filter--visible').length > 0) {
            $('.js-open-small-filter').removeClass('c-list-filters__footer-list-link--active');
            $('.js-small-filter-container').removeClass('c-small-filter--visible');
        }
    }

    $('.js-small-filter-container').click(function (e) {
        if ($(e.target).hasClass('js-close-small-filter')) {
            e.preventDefault();
        } else {
            e.stopPropagation();
        }
    });

    $(document).on('click', '.js-open-small-filter', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.js-open-small-filter').not(this).removeClass('c-list-filters__footer-list-link--active');
        $('.js-small-filter-container').not($(this).siblings('.js-small-filter-container')).removeClass('c-small-filter--visible');
        $(this).toggleClass('c-list-filters__footer-list-link--active');
        $(this).siblings('.js-small-filter-container').toggleClass('c-small-filter--visible');
    });

    $(document).on('click', 'body', function () {
        closeSmallFilters();
    });

    $('body').keydown(function (e) {
        if (e.keyCode == 13 && $('.c-small-filter--visible').length > 0) {
            e.preventDefault();
            $('.c-small-filter--visible').find('.js-small-filter-confirm').trigger('click');
        }
    });

    // Handle clicks on sorting.
    function sortAds(sort) {
        // add to url sort parameter
        let newUrl = new URL(window.location.href);
        let params = new URLSearchParams(newUrl.search);
        let geoLocation = $(this).data('geoLocation');

        params.set('sortBy', sort);

        if (sort === '4') {
            params.set('GeoLocation', geoLocation);

            // Add position to all filtering forms.
            $('input[name=GeoLocation][type=hidden]').each(function () {
                $(this).val(geoLocation);
            });
        }

        newUrl.search = params;
        newUrl = newUrl.toString();

        history.pushState({}, null, newUrl);

        // Update all filtering forms to new order value
        $('input[name=SortBy][type=hidden]').each(function () {
            $(this).val(sort);
        });

        $('.js-ads-container').empty();

        loadMoreAds();

        $('.js-page').each(function () {
            var page = $(this);
            var pageUrl = page.attr('href');

            if (pageUrl) {
                // Replace query param sortBy in href
                var index = pageUrl.indexOf('?');
                var pageSearch = index <= 0 ? "" : pageUrl.substring(index + 1);
                let newPageParams = new URLSearchParams(pageSearch);
                newPageParams.set('sortBy', sort);

                if (sort === '4') {
                    newPageParams.set('GeoLocation', geoLocation);
                }

                var newPageUrl = pageUrl.substring(0, index) + '?' + newPageParams.toString()
                page.attr('href', newPageUrl);
            }
        });
    }

    function sortWithGeolocation(sort) {
        let revert = function () {
            let newUrl = new URL(window.location.href);
            let params = new URLSearchParams(newUrl.search);

            let originValue = params.get('sortBy') ?? 0;
            $('.js-ad-sort-select').val(originValue);
        }
        navigator.geolocation.getCurrentPosition(function (position) {
            const locationParam = position.coords.latitude + ',' + position.coords.longitude;
            $(this).data('geoLocation', locationParam);

            sortAds(sort);
        },
            function (error) {
                if (error.code === GeolocationPositionError.PERMISSION_DENIED) {
                    revert();
                    showFlashMessage('Přístup k poloze je pro tento web blokován vaším prohlížečem.', true);
                }
                else if (error.code === GeolocationPositionError.POSITION_UNAVAILABLE) {
                    revert();
                    showFlashMessage('Poloha je aktuálně nedostupná.', true);
                }
                else {
                    sortWithGeolocation(sort);
                }
            }
        );
    }

    $(document).on('change', '.js-ad-sort-select', function (e) {
        e.preventDefault();

        var sort = $(this).val();
        if (sort === '4') {
            sortWithGeolocation(sort)
        } else {
            sortAds(sort);
        }
    });

    function getSearchData() {
        var adsContainer = $('.js-ads-container');
        let sortBy = $('#ad-list-sort option:selected').val();
        let category = adsContainer.data('category');
        let collection = adsContainer.data('collection');

        let data = {
            sortBy: sortBy,
            category: category,
            collection: collection
        };

        return data;
    }

    function addPageToHistory(data) {

        const url = window.location.href.split('?', 2);
        const loc = url[0];
        const params = new URLSearchParams(url.length > 1 ? url[1] : "");
        history.pushState(data, document.title, `${loc}?${params.toString()}`);
    }

    function removeSearchDataFromQuery(paramName, search) {
        var regex = new RegExp("([?;&])" + paramName + "[^&;]*[;&]?");
        let query = search.replace(regex, "$1").replace(/&$/, '');

        return query === "?" ? '' : query;
    }

    function loadMoreAds() {
        var loadTrigger = $('.js-load-more');
        let data = getSearchData();
        let searchQuery = location.search;

        $.each(data, function (key) {
            searchQuery = removeSearchDataFromQuery(key, searchQuery);
        });

        loadTrigger.show();

        $.ajax({
            type: 'GET',
            url: `/inzeraty/Search${searchQuery}`,
            contentType: 'application/json; charset=utf-8',
            data: data,
            success: function (result) {
                if (result.length > 0) {
                    $('.js-ads-container').append(result);
                }

                loadTrigger.hide();
                addPageToHistory(data);
            },
            error: function () {
                alert('Nepodařilo se načíst další produkty');
                setTimeout(function () {
                    loadTrigger.hide();
                }, 200);
            }
        });
    }

    $(document).on('click', '.js-load-more', function (e) {
        e.preventDefault();
        loadMoreAds();
    });

    function refreshDepndentFilters() {
        var $changedInput = $(this);
        var changedMetadataId = $changedInput.closest('.js-relational-filter').attr('data-id');

        $('.js-relational-filter').each(function () {
            var $filterGroup = $(this);
            var dependsOn = $filterGroup.attr('data-depends-on').split(';').filter(function (d) { return d; });
            var dependentId = $filterGroup.attr('data-id');
            var categoryId = $filterGroup.attr('data-category-id');
            var htmlName = $filterGroup.attr('data-html-name');
            var htmlId = $filterGroup.attr('data-html-id');
            var requireVerificationToken = $(this).closest('form').find('input[name=__RequestVerificationToken]').val();

            if (dependsOn.indexOf(changedMetadataId) < 0) {
                return;
            }

            var data = {
                categoryId: categoryId,
                metadataItemId: dependentId,
                requirements: [],
                __RequestVerificationToken: requireVerificationToken
            };

            for (var i = 0; i < dependsOn.length; i++) {
                var dependedId = dependsOn[i];
                $('[data-id=' + dependedId + '] .o-checkbox__input:checked').prev().each(function () {
                    data.requirements.push({ metadataItemId: dependedId, value: $(this).val() });
                });
            }

            if (data.requirements.length == 0) {
                $filterGroup.hide();
            } else {
                $.ajax({
                    method: 'POST',
                    url: '/inzeraty/FindMetadataValue',
                    data: data,
                    success: function (items) {
                        var wrapper = $filterGroup.find('.js-filter-input-wrapper');
                        wrapper.find('.c-filter-popup__input-container').remove();

                        for (var i = 0; i < items.length; i++) {
                            var item = items[i];
                            var template = `
                            <div class="c-filter-popup__input-container">
                                <label for="${htmlId}_Values_${i}__Selected" class="c-filter-popup__checkbox o-checkbox" >
                                    <input id="${htmlId}_Values_${i}__Value" name="${htmlName}.Values[${i}].Value" value="${item.value}" type="hidden">
                                    <input id="${htmlId}_Values_${i}__Selected" name="${htmlName}.Values[${i}].Selected" class="o-checkbox__input" type="checkbox" value="true">
                                    <div class="c-filter-popup__checkbox-graphics o-checkbox__graphics o-checkbox__graphics--light o-checkbox__graphics--large"></div>
                                    <span class="c-filter-popup__checkbox-label o-checkbox__label">${item.name}</span>
                                </label>
                            </div>`;

                            wrapper.append($(template));
                        }

                        $filterGroup.find('.js-filter-more-link').remove();

                        if (items.length > 4) {
                            $filterGroup.append($(`<a href="#" class="c-filter-popup__more-link js-filter-more-link">Zobrazit vše</a>`));
                        }

                        if (items.length == 0) {
                            $filterGroup.hide();
                        } else {
                            $filterGroup.show();
                        }
                    }
                });
            }
        });
    }

    $('.js-filter-group-title').each(function () {
        if ($(this).html() == '') {
            $(this).addClass('c-filter-popup__group-title--empty');
        }
    });

    $(document).on('change', '.js-relational-filter .o-checkbox__input', refreshDepndentFilters);

    // Submit button
    function DisableSubmit() {
        $(".js-filter-popup-submit").prop("disabled", true);
    }

    function EnableSubmit() {
        $(".js-filter-popup-submit").removeAttr('disabled');
    }
});